import { connect } from "react-redux";
import OktaLogin from "./OktaLogin.js";
import {
  mapStateToProps,
  mapDispatchToProps
} from "../admin-login/AdminLogin.state.js";
export default connect(mapStateToProps, mapDispatchToProps)(OktaLogin);
